import { render, staticRenderFns } from "./UpgradeVersion.vue?vue&type=template&id=4246adf5&"
import script from "./UpgradeVersion.vue?vue&type=script&lang=js&"
export * from "./UpgradeVersion.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeVersion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports